import React from 'react';
import { Button, IconSpinner, InlineTextButton } from '../../../components';
import { trimDisplayNameLastWord } from '../../../util/text';
import { useCopyToClickBoard } from '../../../hooks/useCopyToClickBoard';
import css from './ContactInfo.css';
import { contactOptions, CONTACT_OPTIONS_PHONE_NUMBER_KEY } from '../../../contactOptions-config';
import { useSelector } from 'react-redux';
import classNames from 'classnames';
import { IconCheckmarkStrongL } from '../../../icons';
import { contactViaActionUrl } from '../util/contactViaActionUrl';

const ContactInfo = ({
    isOwnMessage,
    otherParty,
    txSharedContactInfo,
    openContactPreferenceModal,
    fetchTxSharedContactInfoInProgress,
    fetchTxSharedContactInfoError,
}) => {
    const currentUser = useSelector(s => s['user'].currentUser);
    const { copied, copyToClickBoard } = useCopyToClickBoard({ resetAfterMilSeconds: 2000 });

    if (fetchTxSharedContactInfoInProgress) return <IconSpinner />;

    if (typeof fetchTxSharedContactInfoError === 'string')
        return <div style={{ color: 'red' }}>{fetchTxSharedContactInfoError}</div>;

    if (!otherParty) {
        return null;
    }

    const otherPartyPhoneNumber = txSharedContactInfo?.phoneNumber;
    const otherPartyFirstName = trimDisplayNameLastWord(
        otherParty?.attributes?.profile?.displayName
    );

    const {
        key: otherPartyContactPreferenceKey,
        label: otherPartyContactPreferenceLabel,
    } = contactOptions.find(
        option => option?.key === otherParty?.attributes?.profile?.publicData?.contactPreference
    ) || { key: CONTACT_OPTIONS_PHONE_NUMBER_KEY, label: 'Anrufen' };

    const { label: currentUserContactPreferenceLabel } = contactOptions.find(
        option => option?.key === currentUser?.attributes?.profile?.publicData?.contactPreference
    ) || { key: CONTACT_OPTIONS_PHONE_NUMBER_KEY, label: 'Anruf' };

    const otherPartyHasDefaultContactPreference =
        otherPartyContactPreferenceKey === CONTACT_OPTIONS_PHONE_NUMBER_KEY;

    if (isOwnMessage) {
        return (
            <div className={css.contactBlock}>
                <p>
                    Du hast deine Mobilnummer mit <br /> {otherPartyFirstName} geteilt.
                </p>
                <div className={css.delimiter} />
                <footer className={css.contactBlockFooter}>
                    <p>Präferenz: {currentUserContactPreferenceLabel}</p>
                    <InlineTextButton
                        className={css.editContactPrefButton}
                        type="button"
                        onClick={() => openContactPreferenceModal()}
                    >
                        Bearbeiten
                    </InlineTextButton>
                </footer>
            </div>
        );
    }

    return (
        <div className={css.contactBlock}>
            <p>
                {otherPartyFirstName} hat soeben die Mobilnummer <br /> mit dir geteilt.
            </p>

            <div className={css.delimiter} />

            <footer className={classNames(css.contactBlockFooter, css.otherPartyFooter)}>
                <Button
                    className={css.otherPartyActionButton}
                    onClick={() =>
                        contactViaActionUrl(
                            otherPartyContactPreferenceKey,
                            txSharedContactInfo?.phoneNumber
                        )
                    }
                    disabled={!otherPartyPhoneNumber}
                >
                    {otherPartyHasDefaultContactPreference
                        ? 'Anrufen'
                        : `${otherPartyContactPreferenceLabel} öffnen`}
                </Button>

                {copied ? (
                    <InlineTextButton className={css.otherPartyCopyLink}>
                        <IconCheckmarkStrongL />
                    </InlineTextButton>
                ) : (
                    <InlineTextButton
                        className={css.otherPartyCopyLink}
                        type="button"
                        disabled={!otherPartyPhoneNumber}
                        onClick={() => copyToClickBoard(otherPartyPhoneNumber)}
                    >
                        Nummer kopieren
                    </InlineTextButton>
                )}
            </footer>
        </div>
    );
};

export default ContactInfo;
